import React, { useState, useEffect } from "react";
import BgImg from "../../common/backgrounds/BgImg";
import { useNavigate } from "react-router-dom";

import BearGraphicSVG from "../../common/logos/BearGraphic";

import TouchIcon from "./components/UI/TouchIcon";
import HandIcon from "../../common/logos/HandIcon";

export default function WinPage() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(process.env.PUBLIC_URL + "/");
  };

  return (
    <div className="page">
      <BgImg />

      <div className="UI_Block">
        <h1>Well Done!</h1>

        <BearGraphicSVG width={200} />

        <h2>
          <strong>You have completed all 5 levels!</strong>
        </h2>
        <h2>
          Give the password below to the Sales Advisor to claim your very own
          <strong> Billy the Bear! </strong>
        </h2>
        <br />
        <h2>
          PASSWORD:<strong> Billy has been found</strong>
        </h2>
        {/* <p>Description win......</p> */}

        <br />
        <button className="button" onClick={handleClick}>
          Replay Game
        </button>
      </div>
    </div>
  );
}
